import { getAllowedUnits } from 'utils/forms/cuffa_functions';

export function mapApiProductToProdutoSelecionado(produto: any) {
    const allowed = getAllowedUnits(
        produto.name,
        produto.production_type,
        produto.is_processed,
        produto.product_type
    );
    const defaultUnit = allowed.length === 1 ? allowed[0] : 'QUILOGRAMAS';

    return {
        uuid: produto.uuid,
        name: produto.name,
        selecionado: false,
        expandido: false,
        production_area_hectares: null,
        volume_produced: null,
        volume_produced_unit: defaultUnit,
        volume_commercialized: null,
        volume_commercialized_unit: defaultUnit,
        average_commercialized_value: null,
        volume_self_consumption: null,
        volume_self_consumption_unit: defaultUnit,
        volume_lost: null,
        is_processed: produto.is_processed,
        production_type: produto.production_type,
        product_type: produto.product_type,
        volume_lost_unit: defaultUnit,
        availability_months: {
            available_year_round: false,
            january: false,
            february: false,
            march: false,
            april: false,
            may: false,
            june: false,
            july: false,
            august: false,
            september: false,
            october: false,
            november: false,
            december: false
        }
    };
}

export function mergeSavedConventionalProduct(produto: any, savedProduct?: any) {
    if (!savedProduct) return produto;

    const safeParseFloat = (v: any) => {
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
    };

    return {
        ...produto,
        selecionado: true,
        expandido: false,
        production_area_hectares: safeParseFloat(savedProduct?.production_area_hectares) || null,
        volume_produced: safeParseFloat(savedProduct?.volume_produced) || null,
        volume_produced_unit: (savedProduct?.volume_produced_unit) || 'QUILOGRAMAS',
        volume_commercialized: safeParseFloat(savedProduct?.volume_commercialized) || null,
        volume_commercialized_unit: (savedProduct?.volume_commercialized_unit) || 'QUILOGRAMAS',
        average_commercialized_value: safeParseFloat(savedProduct?.average_commercialized_value) || null,
        volume_self_consumption: safeParseFloat(savedProduct?.volume_self_consumption) || null,
        volume_self_consumption_unit: (savedProduct?.volume_self_consumption_unit) || 'QUILOGRAMAS',
        volume_lost: safeParseFloat(savedProduct?.volume_lost) || null,
        volume_lost_unit: (savedProduct?.volume_lost_unit) || 'QUILOGRAMAS',
        is_processed: savedProduct.is_processed,
        production_type: savedProduct.production_type,
        product_type: savedProduct.product_type,
        availability_months: savedProduct?.availability_months || produto.availability_months
    };
}

export default {};
